import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { OneWayInServiceDto } from 'src/api/v2';
import DataTableV3 from 'src/components/DataTableV3';

const ServicesTable = ({
  data,
  columns,
  title,
  isLoading,
  tableId,
}: {
  data: OneWayInServiceDto[];
  columns: ColumnDef<OneWayInServiceDto, any>[];
  title: string;
  isLoading: boolean;
  tableId: string;
}) => {
  return (
    <div className="box borderless background-color--white flex--1">
      <h2 className="margin-bottom--0">{title}</h2>
      <DataTableV3
        id={tableId}
        disableSelection={true}
        loading={isLoading}
        data={data}
        columns={columns}
        disableColumnEditor
        disableExport
        disableGlobalFilter
        hideFilterText
      />
    </div>
  );
};

export default ServicesTable;
